/**
 * Function for consoling okta content using console group and console table.
 * @param tableName name of the table that will be displayed in the console as heading for group
 * @param tableData table like data ex: list, class, object
 * @param extraMessage (optional) any extra text want to display in the console along with table.
 */
export function logOktaDataInTable(tableName: string, tableData: object, ...extraMessage: any[]) {
    console.group("OKTA", " - ", tableName);
    console.table(tableData);
    extraMessage.length && console.log(...extraMessage);
    console.groupEnd();
}


// WEBPACK FOOTER //
// ./src/app/new-login-widget/models/new-login-widget-logger.ts